import { PALETTE } from './sprites'

// Draw one sprite onto a canvas context at (ox, oy), 1 pixel per cell.
function paint(ctx, rows, ox = 0, oy = 0) {
  rows.forEach((row, y) => {
    for (let x = 0; x < row.length; x++) {
      const color = PALETTE[row[x]]
      if (!color) continue
      ctx.fillStyle = color
      ctx.fillRect(ox + x, oy + y, 1, 1)
    }
  })
}

// Render a sprite to a data URL at native resolution. Display it with
// `image-rendering: pixelated` and scale up with CSS.
export function spriteUrl(rows) {
  const canvas = document.createElement('canvas')
  canvas.width = rows[0].length
  canvas.height = rows.length
  paint(canvas.getContext('2d'), rows)
  return canvas.toDataURL()
}

// Render several same-sized frames side by side into one sheet.
export function sheetUrl(frames) {
  const w = frames[0][0].length
  const h = frames[0].length
  const canvas = document.createElement('canvas')
  canvas.width = w * frames.length
  canvas.height = h
  const ctx = canvas.getContext('2d')
  frames.forEach((rows, i) => paint(ctx, rows, i * w, 0))
  return canvas.toDataURL()
}
